import { DisplayBenefitType } from '@witkac/kartamiejska-shared';

import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'benefit',
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa usługi',
      type: 'string',
      fieldRequired: true,
      maxLength: 500
    },
    description: {
      title: 'Opis usługi',
      type: 'string'
    },
    type: {
      title: 'Rodzaj rabatu',
      type: 'string',
      fieldRequired: true
    },
    value: {
      title: 'Wysokość rabatu',
      type: 'number',
      fieldRequired: true,
      validFunc: `this.type === '${DisplayBenefitType.PERCENT_DISCOUNT}' ? $value <= 100 : true`,
      validationMessages: {
        validFunc: 'Maksymalna wartość rabatu to 100%'
      },
      minimum: 0
    },
    groupIds: {
      title: 'Grupy',
      type: 'array',
      items: {
        type: 'number'
      },
      minItems: 1,
      validationMessages: { minItems: 'Należy wybrać przynajmniej jedną grupę użytkowników.' }
    },
    categoryIds: {
      title: 'Grupy',
      type: 'array',
      items: {
        type: 'number'
      },
      calc: 'this.categoryId ? [this.categoryId] : []'
    },
    categoryId: {
      computed: true,
      title: 'Kategoria',
      type: 'number',
      fieldRequired: true,
      validationMessages: { required: 'Należy wybrać kategorię usługi.' },
      calc: {
        when: '!this.categoryId && this.categoryIds && this.categoryIds.length',
        func: 'this.categoryIds[0]'
      }
    },
    placeId: {
      title: 'Obiekt',
      type: 'number',
      default: null
    },
    pointContainerId: {
      title: 'Identyfikator kontenera',
      type: 'number',
      default: null,
      fieldRequired: '!!this.pointCost'
    },
    pointCost: {
      title: 'Koszt w punktach',
      type: 'number',
      default: null
    },
    start: {
      title: 'Początek ważności usługi',
      type: 'string',
      format: 'date'
    },
    end: {
      title: 'Koniec ważności usługi',
      type: 'string',
      format: 'date',
      minimum: 'this.start'
    },
    max: {
      type: 'number',
      title: 'Maksymalna liczba użyć'
    },
    maxPerUser: {
      type: 'number',
      title: 'Maksymalna liczba użyć jednego użytkownika',
      validFunc: '$value && this.max ? $value <= this.max : true',
      validationMessages: {
        validFunc: 'Maksymalna liczba użyć jednego użytkownika nie może być większa niż maksymalna liczba użyć'
      }
    },
    maxPerUserPeriod: {
      type: 'string',
      title: 'Okres'
    },
    images: {
      title: 'Galeria',
      type: 'string',
      default: ''
    },
    mainImage: {
      title: 'Obrazek tła',
      type: 'number'
    },
    descriptionShort: {
      type: 'string',
      maxLength: 500
    },
    defaultPrice: {
      type: 'money',
      title: 'Domyślna cena'
    },
    defaultAmount: {
      type: 'number',
      title: 'Domyślna liczba użyć/minut'
    },

    waitTimeMinutes: {
      computed: true,
      type: 'number',
      title: 'Czas karencji w minutach',
      minimum: 0
    },

    state: {
      title: 'Status',
      type: 'string',
      required: false
    },

    waitTimeSeconds: {
      computed: true,
      type: 'number',
      title: 'Czas karencji w sekundach',
      minimum: 0,
      maximum: 59
    },

    waitTime: {
      type: 'number',
      title: 'Czas karencji w sekundach',
      calc: '(this.waitTimeMinutes || 0) * 60 + (this.waitTimeSeconds || 0)'
    },
    shared: {
      type: 'boolean',
      default: false
    }
  }
};
